export function esc_title( string ) {
	string = string.toLowerCase().replace( /[áàâå]/g, 'a' )
		.replace( /[ø]/g, 'o' )
		.replace( /[úùû]/g, 'u' )
		.replace( /[äæ]/g, 'ae' )
		.replace( /[ö]/g, 'oe' )
		.replace( /[ü]/g, 'ue' )
		.replace( /[ß]/g, 'ss' )
		.replace( /[éèë]/g, 'e' )
		.replace( /[í]/g, 'i' );
	return string.replace( /[^0-9a-z]/gi, '' );
}

export function clamp( value, min, max ) {
	if ( value < min ) return min;
	if ( value > max ) return max;
	return value;
}